import { api } from "./api.service";

export interface MyNextAppointment {
  id: string;
  scheduleId: string;
  startTime: string;
  endTime: string;
  status:
    | 'PENDENTE'
    | 'CONFIRMADO'
    | 'CANCELADO'
    | 'CONCLUIDO'
    | 'PAGAMENTO_PENDENTE'
    | 'PAGAMENTO_PROCESADO'
    | string;
  doctorName?: string | null;
  medicalRecordId?: string | null;
  local?: {
    id: string;
    localName?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip_code?: string | null;
    phone?: string | null;
  } | null;
  pin?: string | null;
}

export async function getMyNextAppointment(): Promise<MyNextAppointment | null> {
  try {
    const { data } = await api.get("/appointments/my-next");
    return data;
  } catch (e: any) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}


export async function getMyAppointments(): Promise<MyNextAppointment[] | null> {
  try {
    const { data } = await api.get("/appointments/my-appointments");
    return data;
  } catch (e: any) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

